// src/app/privacy/privacy.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrivacyService {
  private acceptedKey = 'privacyAccepted'; // Key for session storage
  hideLangSign = new BehaviorSubject<boolean>(false);
  constructor(private httpClient: HttpClient) {}

  setHideSignLang(value: boolean) {
    this.hideLangSign.next(value);
  }
  // Method to check if the privacy policy is accepted
  isPrivacyAccepted(): boolean {
    const accepted = sessionStorage.getItem(this.acceptedKey);
    return accepted === 'true'; // Check the value from session storage
  }

  // Method to set the privacy policy as accepted
  setPrivacyAccepted(value: boolean): void {
    sessionStorage.setItem(this.acceptedKey, String(value)); // Save to session storage
  }

  resetPrivacyAcceptance(): void {
    sessionStorage.removeItem(this.acceptedKey); // Reset the acceptance in session storage
  }

  loadPrivacyNoticeDialogContent(lang: string) {
    return this.httpClient.get(`assets/html/privacy-${lang}.html`, { responseType: 'text' });
  }
}
